module.exports = __webpack_public_path__ + "img/Abnormal.6340eeaf.png";